import ICollection, { ICollectionProduct } from "../entities/ICollection";
import Axios from "./Axios";
import ENDPOINTS from "./endpoints";
import { promoDateToMs } from "./textUtils";

const slugify = (name: string) =>
  name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");






const toApiDateTime = (val?: string | null): string | null => {
  if (!val) return null;
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString().replace(/\.\d{3}Z$/, "Z");
};

const getCollections = () => {
  return Axios.get<Array<ICollection>>(ENDPOINTS.collections.all);
};

const getCollectionById = (id: number) => {
  return Axios.get<ICollection>(ENDPOINTS.collections.byId(id));
};

const createCollection = (
  name: string,
  products: Array<ICollectionProduct>,
  shopId?: number,
  startsAt?: string | null,
  endsAt?: string | null
) => {
  const payload = {
    shopId: shopId ?? null,
    name,
    slug: slugify(name),
    type: "null",
    rules: null,

    display_order: 0,

    statusId: true,
    starts_at: startsAt || null,
    ends_at: endsAt || null,
    collectionProductRequestDtos: products.map((p, i) => ({
      productId: p.productId,
      isActive: p.isActive ?? 1,
      displayOrder: p.displayOrder ?? i,
    })),
  };
  return Axios.post<ICollection>(ENDPOINTS.collections.create, payload);
};



const isCollectionExpired = (collection: ICollection): boolean => {
  const endTime = promoDateToMs(collection.ends_at);
  if (endTime === null) return false;
  return endTime <= Date.now();
};

const isCollectionUpcoming = (collection: ICollection): boolean => {
  const startTime = promoDateToMs(collection.starts_at);
  if (startTime === null) return false;
  return startTime > Date.now();
};

const updateCollection = (id: number, data: Partial<ICollection>) => {
  return Axios.put<ICollection>(ENDPOINTS.collections.update(id), data);
};

const deleteCollection = (id: number) => {
  return Axios.delete(ENDPOINTS.collections.delete(id));
};

const CollectionService = {
  getCollections,
  getCollectionById,
  createCollection,
  updateCollection,
  deleteCollection,
  slugify,
  isCollectionExpired,
  isCollectionUpcoming,
  toApiDateTime,
};

export default CollectionService;
